<template>
    <div class="h5">
        <div class="h5__nav">{{ step == 'ok' ? '提交成功' : '信息填写' }}</div>

        <div v-if="step == 'loading' || step == 'submitting'" class="h5__card h5__loading">
            <div class="h5__spin"></div>
            <p>{{ step == 'loading' ? '正在加载，请稍候…' : '正在提交，请稍候…' }}</p>
        </div>

        <template v-else-if="step == 'form'">
            <div class="h5__hero">
                <h1>专属客服服务</h1>
                <p>请填写以下信息，提交后添加专属客服为微信好友</p>
            </div>
            <div class="h5__form">
                <div v-for="item in config.fields" :key="item.key" class="h5__row" :class="{ 'h5__row--bad': errors.indexOf(item.key) >= 0 }">
                    <div class="h5__row-hd">
                        <span v-if="item.required" class="h5__req">*</span>
                        <span>{{ item.label }}</span>
                        <span v-if="!item.required" class="h5__opt">选填</span>
                    </div>
                    <select v-if="item.key == 'sex'" :value="values[item.key] || ''" @change="onInput(item.key, $event.target.value)">
                        <option value="">请选择</option>
                        <option value="男">男</option>
                        <option value="女">女</option>
                    </select>
                    <input
                        v-else
                        :value="values[item.key] || ''"
                        :placeholder="fieldMeta(item.key).ph"
                        :inputmode="fieldMeta(item.key).mode"
                        @input="onInput(item.key, $event.target.value)"
                    >
                    <div class="h5__row-err">请填写{{ item.label }}</div>
                </div>
            </div>
            <div class="h5__agree">提交即表示同意我们使用以上信息与你联系<br>信息仅用于本次服务，不会对外提供</div>
            <button class="h5__submit" @click="submit">提交并添加好友</button>
        </template>

        <template v-else-if="step == 'ok'">
            <div class="h5__card h5__result">
                <div class="h5__ico h5__ico--ok">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>
                </div>
                <h2>提交成功</h2>
                <p>信息已记录，请长按识别下方二维码<br>添加专属客服为微信好友</p>
            </div>
            <div class="h5__card h5__qr-wrap">
                <img v-if="qrCode" class="h5__qr-img" :src="qrCode" alt="添加好友二维码">
                <div v-else class="h5__qr-empty">二维码获取失败，请点击「重新获取」</div>
                <div class="h5__qr-tip">长按识别二维码添加好友</div>
            </div>
            <div class="h5__foot">如二维码无法识别，请联系门店工作人员</div>
        </template>

        <template v-else-if="step == 'err'">
            <div class="h5__card h5__result">
                <div class="h5__ico h5__ico--bad">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 7v7M12 17.5v.5"/></svg>
                </div>
                <h2>活码生成失败</h2>
                <p>你的信息已保存，但坐席活码生成失败<br>请点击下方按钮重新获取</p>
                <p v-if="failReason" class="h5__fail">{{ failReason }}</p>
            </div>
            <button class="h5__submit" @click="retry">重新获取</button>
            <button class="h5__ghost" @click="again">重新填写</button>
        </template>

        <template v-else>
            <div class="h5__card h5__result">
                <div class="h5__ico h5__ico--gray">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7.5V12l3 2"/></svg>
                </div>
                <h2>活动已结束</h2>
                <p>{{ closedMessage }}</p>
            </div>
            <div class="h5__foot">如有疑问，请联系门店工作人员</div>
        </template>
    </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { newopenh5config, newopenh5submit, newopenh5retry } from '@/assets/js/common.js'

const route = useRoute()

//当前状态：loading/form/submitting/ok/err/closed
const step = ref('loading')
//收集码配置
const config = reactive({
    code_id: 0,
    name: '',
    seat_names: [],
    fields: [],
    tag_names: []
})
//填写内容
const values = reactive({})
//校验未通过的字段
const errors = ref([])
//提交/重试成功后的活码
const qrCode = ref('')
const token = ref('')
//建码失败原因
const failReason = ref('')
//关闭态提示
const closedMessage = ref('')

//各字段的输入提示与键盘类型
const FIELD_META = {
    name: { ph: '请输入真实姓名', mode: '' },
    mobile: { ph: '请输入手机号', mode: 'numeric' },
    birthday: { ph: '如 1990-05-20', mode: '' },
    sex: { ph: '', mode: '' },
    area: { ph: '如 上海市 静安区', mode: '' },
    address: { ph: '请输入详细地址', mode: '' },
    idcard: { ph: '请输入身份证号', mode: 'numeric' }
}
const fieldMeta = (key) => FIELD_META[key] || { ph: '', mode: '' }

//弹窗关闭态
const closeWith = (message) => {
    closedMessage.value = message || '该收集码已停止使用'
    step.value = 'closed'
}

//加载收集码配置
const getconfig = () => {
    const codeId = Number(route.query.code) || 0
    if (!codeId) {
        closeWith('链接不存在或已删除')
        return
    }
    newopenh5config({ code_id: codeId }).then((response) => {
        if (response.data.msg.code != 0) {
            closeWith(response.data.msg.info || '收集码加载失败，请稍后重试')
            return
        }
        const data = response.data.data
        if (data.state != 'ok') {
            closeWith(data.close_message)
            return
        }
        config.code_id = data.code_id
        config.name = data.name
        config.seat_names = data.seat_names || []
        config.fields = data.fields || []
        config.tag_names = data.tag_names || []
        step.value = 'form'
    }).catch(() => {
        closeWith('网络异常，请稍后刷新重试')
    })
}

//输入时同步值并清掉该字段的错误态
const onInput = (key, value) => {
    values[key] = value
    if (errors.value.indexOf(key) >= 0) {
        errors.value = errors.value.filter((item) => item !== key)
    }
}

//必填校验
const validate = () => {
    errors.value = config.fields
        .filter((item) => item.required && !(values[item.key] || '').trim())
        .map((item) => item.key)
    return errors.value.length == 0
}

//提交填写
const submit = () => {
    if (!validate()) {
        return
    }
    step.value = 'submitting'
    const payload = { code_id: config.code_id, values: {} }
    config.fields.forEach((item) => {
        payload.values[item.key] = (values[item.key] || '').trim()
    })
    newopenh5submit(payload).then((response) => {
        if (response.data.msg.code != 0) {
            closeWith(response.data.msg.info || '提交失败，请稍后重试')
            return
        }
        applyResult(response.data.data)
    }).catch(() => {
        step.value = 'err'
        failReason.value = '网络异常，请点击「重新获取」'
    })
}

//重试建码
const retry = () => {
    if (!token.value) {
        step.value = 'form'
        return
    }
    step.value = 'submitting'
    newopenh5retry({ token: token.value }).then((response) => {
        if (response.data.msg.code != 0) {
            step.value = 'err'
            failReason.value = response.data.msg.info || ''
            return
        }
        applyResult(response.data.data)
    }).catch(() => {
        step.value = 'err'
        failReason.value = '网络异常，请稍后重试'
    })
}

//提交/重试结果落到页面状态
const applyResult = (data) => {
    if (data.state == 'ok') {
        token.value = data.token || token.value
        qrCode.value = data.qr_code || ''
        step.value = 'ok'
        window.scrollTo(0, 0)
        return
    }
    if (data.state == 'build_failed') {
        token.value = data.token || token.value
        failReason.value = data.fail_reason || ''
        step.value = 'err'
        window.scrollTo(0, 0)
        return
    }
    closeWith(data.close_message)
}

//再填一份
const again = () => {
    Object.keys(values).forEach((key) => {
        delete values[key]
    })
    errors.value = []
    qrCode.value = ''
    token.value = ''
    failReason.value = ''
    step.value = 'form'
    window.scrollTo(0, 0)
}

onMounted(() => {
    getconfig()
})
</script>
<style scoped>
.h5 {
    max-width: 430px;
    min-height: 100vh;
    margin: 0 auto;
    background: #F7F8FC;
    padding-bottom: calc(28px + env(safe-area-inset-bottom));
    color: #1E293B;
    font-size: 14px;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
}
.h5__nav {
    position: sticky;
    top: 0;
    z-index: 10;
    height: 44px;
    background: #fff;
    border-bottom: 1px solid #E8ECF3;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 600;
    padding: 0 44px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.h5__hero {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    margin: 12px 12px 0;
    padding: 18px 16px 16px;
}
.h5__hero h1 {
    margin: 0 0 7px;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: .2px;
    line-height: 1.35;
}
.h5__hero p {
    margin: 0;
    font-size: 13px;
    color: #64748B;
    line-height: 1.65;
}
.h5__hero p b {
    color: #4F46E5;
    font-weight: 600;
}
.h5__form {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    margin: 12px 12px 0;
    padding: 2px 16px;
}
.h5__row {
    padding: 13px 0;
    border-bottom: 1px solid #E8ECF3;
}
.h5__row:last-child {
    border-bottom: 0;
}
.h5__row-hd {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    margin-bottom: 7px;
}
.h5__req {
    color: #EF4444;
    font-size: 14px;
    line-height: 1;
}
.h5__opt {
    color: #94A3B8;
    font-size: 12px;
    margin-left: auto;
}
.h5__row input,
.h5__row select {
    width: 100%;
    height: 42px;
    padding: 0 12px;
    border: 1px solid #E8ECF3;
    border-radius: 8px;
    background: #fff;
    font-size: 15px;
    color: #1E293B;
    outline: none;
}
.h5__row input::placeholder {
    color: #94A3B8;
    font-size: 14px;
}
.h5__row select {
    appearance: none;
}
.h5__row input:focus,
.h5__row select:focus {
    border-color: #A5B4FC;
    box-shadow: 0 0 0 3px #EEF2FF;
}
.h5__row--bad input,
.h5__row--bad select {
    border-color: #EF4444;
    background: #FEF5F5;
}
.h5__row-err {
    display: none;
    color: #EF4444;
    font-size: 12px;
    margin-top: 6px;
}
.h5__row--bad .h5__row-err {
    display: block;
}
.h5__agree {
    margin: 38px 16px 0;
    font-size: 11.5px;
    color: #94A3B8;
    text-align: center;
    line-height: 1.7;
}
.h5__submit {
    display: block;
    width: calc(100% - 24px);
    margin: 12px auto 0;
    height: 46px;
    border-radius: 8px;
    border: 0;
    background: #4F46E5;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: .5px;
    box-shadow: 0 6px 16px rgba(79, 70, 229, .24);
}
.h5__submit:active {
    background: #4338CA;
}
.h5__ghost {
    display: block;
    width: calc(100% - 24px);
    margin: 10px auto 0;
    height: 46px;
    border-radius: 8px;
    border: 0;
    background: #fff;
    color: #64748B;
    font-size: 15px;
    box-shadow: inset 0 0 0 1px #E8ECF3;
}
.h5__ghost:active {
    background: #F1F3F9;
}
.h5__card {
    background: #fff;
    border-radius: 14px;
    box-shadow: 0 1px 3px rgba(15, 23, 42, .06), 0 10px 30px rgba(79, 70, 229, .06);
    margin: 12px 12px 0;
    padding: 16px;
}
.h5__loading {
    padding: 80px 16px;
    text-align: center;
}
.h5__spin {
    width: 30px;
    height: 30px;
    margin: 0 auto 14px;
    border-radius: 50%;
    border: 3px solid #C7D2FE;
    border-top-color: #4F46E5;
    animation: h5spin .8s linear infinite;
}
@keyframes h5spin {
    to { transform: rotate(360deg); }
}
.h5__loading p {
    margin: 0;
    font-size: 14px;
    color: #64748B;
}
.h5__result {
    padding: 26px 16px 22px;
    text-align: center;
}
.h5__ico {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    margin: 0 auto 12px;
    display: grid;
    place-items: center;
}
.h5__ico--ok {
    background: rgba(16, 185, 129, .12);
    color: #10B981;
}
.h5__ico--bad {
    background: rgba(239, 68, 68, .12);
    color: #EF4444;
}
.h5__ico--gray {
    background: #F1F3F9;
    color: #94A3B8;
}
.h5__result h2 {
    margin: 0 0 7px;
    font-size: 17px;
    font-weight: 800;
}
.h5__result p {
    margin: 0;
    font-size: 13px;
    color: #64748B;
    line-height: 1.7;
}
.h5__result p b {
    color: #1E293B;
    font-weight: 600;
}
.h5__fail {
    margin-top: 8px !important;
    color: #EF4444 !important;
    font-size: 12px !important;
    word-break: break-all;
}
.h5__qr-wrap {
    text-align: center;
}
.h5__qr-img {
    display: block;
    width: 148px;
    height: 148px;
    margin: 0 auto 10px;
    padding: 8px;
    background: #fff;
    border: 1px solid #E8ECF3;
    border-radius: 10px;
    object-fit: contain;
}
.h5__qr-empty {
    padding: 40px 0;
    font-size: 13px;
    color: #64748B;
}
.h5__qr-tip {
    font-size: 13px;
    color: #64748B;
}
.h5__sum {
    display: flex;
    justify-content: space-between;
    gap: 14px;
    padding: 7px 0;
    font-size: 13px;
    color: #64748B;
}
.h5__sum + .h5__sum {
    border-top: 1px dashed #E8ECF3;
}
.h5__sum b {
    color: #1E293B;
    font-weight: 600;
    text-align: right;
    word-break: break-all;
}
.h5__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: flex-end;
}
.h5__tag {
    height: 22px;
    padding: 0 9px;
    border-radius: 4px;
    background: #EEF2FF;
    color: #4F46E5;
    font-size: 12px;
    display: inline-flex;
    align-items: center;
}
.h5__foot {
    text-align: center;
    font-size: 11px;
    color: #94A3B8;
    margin-top: 18px;
    line-height: 1.7;
}
@media (min-width: 600px) {
    .h5 {
        box-shadow: 0 18px 50px rgba(15, 23, 42, .10);
    }
}
</style>
